<div class="page-container">
  @if(isModelMenu){
  <mobile-menu
    [profileInfo]="profileInfo()"
    [tabs]="tabs()"
    (action)="modelMenuActions($event)"></mobile-menu>
  }
  <quiz-header
    [profileInfo]="profileInfo()"
    [tabs]="tabs()"
   (action)="modelMenuActions($event)"></quiz-header>
  <div class="router-outlet">
    <router-outlet>
      <!--    <breadcrumb/>-->
    </router-outlet>
  </div>

  <quiz-footer
    [tabs]="tabs()"></quiz-footer>
</div>
